module.exports = __webpack_public_path__ + "static/login-header-786ef3c35401a86ec9b15438a18f3783.png";